var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":_vm.exportData}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fa-file-download")])],1)]}}])},[_c('span',[_vm._v("Download CSV")])])
}
var staticRenderFns = []

export { render, staticRenderFns }